import { Select, SelectProps } from "@chakra-ui/react";
import { SortSelectionData } from "utils/interface";
interface FeatureItemProps extends SelectProps {
  options?: {
    label?: string;
    value?: string;
  }[];
  handler?: (value: string) => void;
  valueData?: string | null;
  placeholder?: string;
}

interface SortItemProps extends SelectProps {
  options?: SortSelectionData[];
  handler?: (value: string) => void;
  valueData?: string;
  placeholder?: string;
}

export const SelectOption = (props: FeatureItemProps) => {
  const { options, handler, valueData, placeholder, ...selectProps } = props;
  return (
    <Select
      {...selectProps}
      variant="main"
      value={valueData ? valueData : undefined}
      onChange={(e) => {
        handler && handler(e.target.value);
      }}
      placeholder={placeholder ?? "All"}
      textTransform={"capitalize"}
    >
      {options !== undefined &&
        options.map((option, key) => (
          <option key={key} value={option.value}>
            {option.label?.toLowerCase()}
          </option>
        ))}
    </Select>
  );
};

export const SelectSortOption = (props: SortItemProps) => {
  const { options, handler, valueData, placeholder, ...selectProps } = props;
  return (
    <Select
      {...selectProps}
      variant="main"
      value={valueData ?? undefined}
      onChange={(e) => {
        handler && handler(e.target.value);
      }}
      placeholder={placeholder ?? "Sort by"}
      textTransform={"capitalize"}
      mr={{ base: 4, md: 12 }}
    >
      {options !== undefined &&
        options.map((option, key) => (
          <option key={key} value={`${option.field} ${option.direction}`}>
            {option.label?.toLowerCase()}
          </option>
        ))}
    </Select>
  );
};
